<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reload="reload" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model="form.keyword"
              :placeholder="
                $l('INDEX.batch_label_search') ||
                  '交货批次号/批次识别单号/目的港口 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              :disabled="disabled"
              variant="outline-success"
              @click="
                $emit('openEditFormDialog', {
                  type: 'add',
                })
              "
            >
              <b-icon-plus></b-icon-plus>{{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              :disabled="disabled"
              variant="outline-danger"
              @click="$emit('batchDel')"
            >
              <i class="el-icon-delete"></i
              >{{ $l('INDEX.btn_delete') || '删除' }}
            </b-button>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('onClickPrint')"
            >
              <i class="el-icon-download"></i
              >{{ $l('INDEX.btn_export') || '导出' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
      <el-dialog
        :title="$l('INDEX.advanced_search') || '高级搜索'"
        :show-close="true"
        :visible.sync="advqueryDialogVisible"
        width="1000px"
        :close-on-click-modal="false"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="130px"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_orderBatchNo') ||
                    '交货批次号'
                "
              >
                <el-input
                  v-model.trim="form.orderBatchNo"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_identifyNo') ||
                    '批次识别单号'
                "
              >
                <el-input v-model.trim="form.identifyNo" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_deliveryType') || '出货方式'"
                prop="deliveryType"
              >
                <dict-select
                  filterable
                  v-model="form.deliveryType"
                  url="/master/common/dict/biz"
                  :body="deliveryTypeParams"
                  size="small"
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_receiver') || '收货人'"
              >
                <el-input v-model.trim="form.receiver" clearable size="small">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_receiverPhone') || '联系电话'"
              >
                <el-input
                  v-model.trim="form.receiverPhone"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_receiverAddress') || '收货地址'"
              >
                <el-input
                  v-model.trim="form.receiverAddress"
                  clearable
                  size="small"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_outBillType') || '出单类型'"
                prop="outBillType"
              >
                <dict-select
                  filterable
                  v-model="form.outBillType"
                  url="/master/common/dict/biz"
                  :body="outBillTypeParams"
                  size="small"
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
                "
                prop="dispatchPort"
              >
                <dict-select
                  filterable
                  v-model="form.dispatchPort"
                  url="/master/port/select"
                  size="small"
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="
                  $l('INDEX.order_form_batch_label_destinationPort') ||
                    '目的港口'
                "
                prop="destinationPort"
              >
                <dict-select
                  filterable
                  v-model="form.destinationPort"
                  url="/master/port/select"
                  size="small"
                  clearable
                >
                </dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$l('INDEX.form_label_brand') || '品牌'">
                <dict-select
                  clearable
                  v-model="form.brandCodeList"
                  filterable
                  multiple
                  url="/master/common/dict/brandSelect"
                  :placeholder="
                    $l('INDEX.form_label_please_select_brand') || '请选择品牌'
                  "
                  size="small"
                  style="width:100%"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('INDEX.batch_label_deliveryDate') || '出货日期'"
              >
                <el-row>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginDeliveryDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="beginDeliveryDatePicker"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endDeliveryDate"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="endDeliveryDatePicker"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item
                  :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCargoReadyDay"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="beginCargoReadyDayPicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCargoReadyDay"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :picker-options="endCargoReadyDayPicker"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeAdvqueryDialog">{{
            $l('INDEX.btn_cancel_query') || '取消查询'
          }}</el-button>
          <el-button size="small" type="warning" @click="reload">{{
            $l('INDEX.btn_reset_filter') || '重置条件'
          }}</el-button>
          <el-button size="small" type="primary" @click="advquery">{{
            $l('INDEX.btn_data_retrieval') || '数据检索'
          }}</el-button>
        </span>
      </el-dialog>
    </b-row>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
}

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      deliveryTypeParams: { dictType: 'deliveryType' },
      outBillTypeParams: { dictType: 'outBillType' },
      beginCargoReadyDayPicker: this.endCargoReadyDay(),
      endCargoReadyDayPicker: this.beginCargoReadyDay(),
      beginDeliveryDatePicker: this.endDeliveryDate(),
      endDeliveryDatePicker: this.beginDeliveryDate(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    //初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reload')
      }
      this.$emit('query', this.form)
    },
    //高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    //重置条件查询
    reload() {
      this.form = { ...initForm }
    },
    //打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    //关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    beginCargoReadyDay() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginCargoReadyDay) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginCargoReadyDay).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    endCargoReadyDay() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endCargoReadyDay) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endCargoReadyDay).getTime() < time.getTime()
            )
          }
        },
      }
    },
    beginDeliveryDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.beginDeliveryDate) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.form.beginDeliveryDate).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
    endDeliveryDate() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.endDeliveryDate) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.form.endDeliveryDate).getTime() < time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
